import React from "react";
import BoardApprovalAssignment from "../../features/BoardApprovalAssignment/BoardApprovalAssignment";

const BoardMemberManagementPage = () => {
  return (
    <div className="board-member-management-page">
      <BoardApprovalAssignment />
    </div>
  );
};

export default BoardMemberManagementPage;
